module.exports = __webpack_public_path__ + "img/00017.678678d0.webp";